import React from 'react';
import { useTranslation } from 'react-i18next';
import { FITOGRAM_BLUE_FADED_9 } from '~/Constants/Colors.constants';
import { Route } from '~/Constants/Routes.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { useNavigation } from '~/Hooks';
import { Button } from '~/UIKit';
import { ExtendedEventGroup } from '../ExtendedEventGroup.model';
import { makeStyles } from '~/UIKit/Style';
import { EventType } from '~/Models/DTO/Event.model';

const useStyles = makeStyles(() => ({
  editEventGroupButtonContainer: {
    background: FITOGRAM_BLUE_FADED_9,
    padding: 15,
    display: 'flex',
    '& + div': {
      paddingTop: '0 !important',
    },
  },
  editEventGroupButtonText: {
    flex: 1,
    lineHeight: '19px',
  },
  editEventGroupButtonTextBold: {
    fontWeight: 'bold',
  },
}));

export const EditEventGroupButton = ({
  eventType,
  eventGroup,
  firstPage,
  disabled = false,
}: {
  eventType: EventType;
  eventGroup: ExtendedEventGroup;
  firstPage?: boolean;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const { classes } = useStyles();

  const gotoGroup = () =>
    navigate(
      routeReplacer(Route.EVENTGROUP_EDIT, {
        groupId: eventGroup.id || 0,
        eventType,
      }),
    );

  if (!eventGroup?.id) {
    return null;
  }

  return (
    <div className={classes.editEventGroupButtonContainer}>
      <div className={classes.editEventGroupButtonText}>
        {firstPage ? (
          <>
            <div>{t('form.field.eventGroup.changeEvents')}</div>
            <div className={classes.editEventGroupButtonTextBold}>
              {t('form.field.eventGroup.editTheGroup')}
            </div>
          </>
        ) : (
          <>
            <div className={classes.editEventGroupButtonTextBold}>
              {t('form.field.eventGroup.groupFeatures')}
            </div>
            <div>{t('form.field.eventGroup.singleEvent')}</div>
          </>
        )}
      </div>
      <Button disabled={disabled} onClick={gotoGroup} variant="contained" size="medium">
        {t('form.field.eventGroup.edit')}
      </Button>
    </div>
  );
};
